mutation BatchTransactionUpdate($input: BatchTransactionUpdateInput!) {
  batchTransactionUpdate(input: $input) {
    clientMutationId
    batchTransaction
    {
        id
      __typename
      _urgencyLevel
      weekNumber
      _isUpdatable
      _isDeletable
      _rowTimestamp
      referenceNumber
      description
      currencyId
      postingDate
      currency {
        isoCode
      }
      _createdByUserName
      _createdByUserid
      companyCorporatePeriod {
        _periodYear
        startDate
        endDate
      }
      corporatePeriodId
      _batchTransactionCount
      _batchTransactionTotal
      controlTotalAmount
      _isStagedApprovalRequest
      statusType {
        statusType
        _transactionIconStatus
      }
    }
  }
}
